!(function () {
    "use strict";
    var e = {
            6072: function (e, t, o) {
                o.d(t, {
                    gp: function () {
                        return c;
                    },
                    hO: function () {
                        return n;
                    },
                });
                const n = function () {
                    let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    const t = window.innerWidth - document.body.offsetWidth,
                        o = document.getElementById("nav-wrapper");
                    e
                        ? (document.body.classList.add("no-scroll"),
                          (document.body.style.paddingRight = t + "px"),
                          (o.style.paddingRight = t + "px"))
                        : (document.body.classList.remove("no-scroll"),
                          (document.body.style.paddingRight = "0px"),
                          (o.style.paddingRight = "0px"));
                };
                let i = () => {};
                const r = (e) => {
                        "Escape" === e.key && (i(), window.removeEventListener("keydown", r));
                    },
                    c = function () {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            t = arguments.length > 1 ? arguments[1] : void 0;
                        t && (i = t),
                            e && window.addEventListener("keydown", r),
                            e || window.removeEventListener("keydown", r);
                    };
                document.querySelectorAll(".local-scroll").forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href");
                        !(function (e) {
                            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                            const o = document.getElementById("nav-wrapper"),
                                n = document.querySelector(".header").getAttribute("data-ux-position"),
                                i = e.getBoundingClientRect().top;
                            window.scrollTo({
                                top:
                                    "off" !== n
                                        ? i + window.scrollY - t + parseFloat(o.style.marginTop)
                                        : i + window.scrollY - t,
                                behavior: "smooth",
                            });
                        })(document.querySelector(t));
                    });
                });
            },
        },
        t = {};
    function o(n) {
        var i = t[n];
        if (void 0 !== i) return i.exports;
        var r = (t[n] = { exports: {} });
        return e[n](r, r.exports, o), r.exports;
    }
    (o.d = function (e, t) {
        for (var n in t) o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }),
        (o.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (function () {
            var e = o(6072);
            function t() {
                const e = document.querySelector(".zoom-lightbox");
                var t, o;
                e && !e.swiper.initialized
                    ? (o = e) &&
                      o.querySelectorAll("figure:not(.figure--model)").forEach((e) => {
                          e.addEventListener("click", () => {
                              c(e.parentNode.getAttribute("data-id"));
                          });
                      })
                    : (t = e) &&
                      t.swiper.on("click", function () {
                          console.log("slider click"),
                              this.slides[this.clickedIndex].getAttribute("data-id") &&
                                  (this.slides[this.clickedIndex].classList.contains("model") ||
                                      this.slides[this.clickedIndex].classList.contains("video") ||
                                      c(this.slides[this.clickedIndex].getAttribute("data-id")));
                      });
            }
            window.addEventListener("load", t),
                Shopify.designMode && document.addEventListener("shopify:section:load", t);
            let n,
                i = [];
            const r = () => {
                (0, e.hO)(!1),
                    (0, e.gp)(!1),
                    n && n.classList.remove("pdp-lightbox--open"),
                    i &&
                        i.length &&
                        Array.from(i).forEach(function (e) {
                            if ("video" === e.tagName.toLowerCase()) e.pause();
                            else {
                                var t = e.src;
                                e.src = t;
                            }
                        });
            };
            if (((n = document.querySelector(".pdp-lightbox")), n)) {
                const e = n.querySelector(".pdp-lightbox__close");
                (i = n.querySelectorAll("iframe, video")),
                    e &&
                        e.addEventListener("click", () => {
                            r();
                        }),
                    n.querySelectorAll(".figure--image").forEach((e) => {
                        e.addEventListener("click", r);
                    });
            }
            const c = (t) => {
                (0, e.hO)(!0),
                    (0, e.gp)(!0, r),
                    n.classList.add("pdp-lightbox--open"),
                    ((e) => {
                        n.scrollTop =
                            n.querySelector('figure[data-id="' + e + '"').offsetTop +
                            parseInt(getComputedStyle(n).paddingTop);
                    })(t);
            };
            function d() {
                const e = document.querySelectorAll(".scroll-atc"),
                sticky = document.querySelector(".sticky-add-to-cart");
            
                if (!sticky) return;           
                document.querySelectorAll(".sticky-add-to-cart").forEach((el, i) => {
                    if (i > 0) el.remove();
                });
            
                document.body.prepend(sticky);
            
                const stickyInner = sticky.querySelector(".sticky-add-to-cart__inner");
                const addToCartBtn = document.querySelector(".main-product__add-to-cart .button--add-to-cart");
                const footer = document.querySelector("footer");
            
                let isFooterVisible = false;           
                
                if (addToCartBtn) {
                    new IntersectionObserver((entries) => {
                        const [entry] = entries;           
                        
                        if (entry.isIntersecting) {
                            sticky.classList.remove("active", "sticky-subheader");
                            stickyInner.classList.remove("sticky-priority");
                            return;
                        }            
                        
                        if (isFooterVisible) {
                            sticky.classList.remove("active", "sticky-subheader");
                            stickyInner.classList.remove("sticky-priority");
                        } else {
                            sticky.classList.add("active", "sticky-subheader");
                            stickyInner.classList.add("sticky-priority");
                        }
                    }, {
                        root: null,
                        threshold: 0.5   
                    }).observe(addToCartBtn);
                }            
                
                if (footer) {
                    new IntersectionObserver((entries) => {
                        const [entry] = entries;
                        isFooterVisible = entry.isIntersecting;                        
                        
                        if (isFooterVisible) {
                            sticky.classList.remove("active", "sticky-subheader");
                            stickyInner.classList.remove("sticky-priority");
                        }
                        
                        else if (!addToCartBtn || !isElementInViewport(addToCartBtn)) {
                            sticky.classList.add("active", "sticky-subheader");
                            stickyInner.classList.add("sticky-priority");
                        }
                    }, {
                        root: null,
                        threshold: 0.1,
                        rootMargin: "0px 0px -80px 0px"  
                    }).observe(footer);
                }            
                
                function isElementInViewport(el) {
                    const rect = el.getBoundingClientRect();
                    return (
                        rect.top >= 0 &&
                        rect.left >= 0 &&
                        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                    );
                }
               
                e.forEach((el) => {
                    el.addEventListener("click", function () {
                        const productSection = document.querySelector(".main-product__add-to-cart");
                        const nav = document.getElementById("nav-wrapper");
                        const variantSelector = document.querySelector(".main-product__variant-selector");
            
                        let offset = 150;
                        let scrollPosition = productSection ? productSection.offsetTop : 0;
            
                        if (nav) offset = nav.clientHeight;
                        if (variantSelector) {
                            scrollPosition = variantSelector.getBoundingClientRect().top + window.scrollY - offset;
                        }
            
                        window.scrollTo({
                            top: scrollPosition - offset,
                            behavior: "smooth"
                        });
            
                        setTimeout(() => {
                            if (variantSelector) {
                                variantSelector.classList.add("ux-shake");
                                setTimeout(() => variantSelector.classList.remove("ux-shake"), 800);
                            }
                        }, 800);
                    });
                });
            }
            window.addEventListener("load", d),
                Shopify.designMode && document.addEventListener("shopify:section:load", d);
        })();
})();
